export const config = {
  IS_PROD: true,
  DB_NAME: "booking-app",
  API_BASE_URL: "https://apiv1-exfuq5nwja-el.a.run.app/",
  TIMEZONE: "Asia/Kolkata",
  RECAPTCHA_SITE_KEY: "6Lek8iUqAAAAANsgybkTf_FHfS1xpb8aWGVzb2NP",
  FEATURE_FLAG_FOR_WAITLIST_ON_BUSINESS_SCREEN: true,
  FEATURE_FLAG_FOR_SHOW_ALL_CATEGORIES: false,
  FEATURE_FLAG_FOR_EMAIL_CAMPAIGNS: false,
  MIXPANEL_TOKEN: "fba028a1fb6a84b99fbb045afa41362d",
  VAPID_KEY:
    "BHKaLkvFtsLTCMfBXjfAZkBRIbrzXQK2DGzAY5oMxgnDxXpB7T--1s8H4HtekcHgOh4UMubtJkJnVUemMlXdoN8",
};

export const firebaseConfig = {
  apiKey: "AIzaSyB9pKOgloFG-BDyIe5iiwFFziqxIDabyIY",
  authDomain: "slotwala-a4b77.firebaseapp.com",
  projectId: "slotwala-a4b77",
  storageBucket: "slotwala-a4b77.appspot.com",
  messagingSenderId: "199938469825",
  appId: "1:199938469825:web:c0d692426080d428758940",
};
